"use client";
import useTranslate from "@app/_hooks/useTranslate";
import type { HeadingProps } from "@components/ui";
import { Heading } from "@components/ui";

import { useCheckoutContext } from "../Checkout.hooks";

export default function CheckoutAddressHeading(props: HeadingProps) {
  const t = useTranslate();
  useCheckoutContext();

  if (!t("checkoutAddressHeading", { strict: true })) {
    return null;
  }

  return (
    <Heading size={5} className="col-span-2 mb-4 text-center" {...props}>
      {t("checkoutAddressHeading")}
    </Heading>
  );
}
